import { useSelector } from 'react-redux';
import { selectQuestionnaireRoutes } from '../../../routes/slice';
import PreviewCurrentAddress from './CurrentAddress/preview';
import PreviewHistory from './History/preview';
import PreviewHousingArrangements from './HousingArrangements/preview';

export interface IPreviewWhereILiveProps {}

export default function PreviewWhereILive(props: IPreviewWhereILiveProps) {
  const routes = useSelector(selectQuestionnaireRoutes).routes;

  return (
    <>
      <h1 className="w-full rounded-t-2xl bg-green text-white px-4  font-semibold pl-6 py-4 mt-8">
        Where I Live
      </h1>
      {routes.personal_details.where_i_live.current_address && (
        <PreviewCurrentAddress />
      )}
      {routes.personal_details.where_i_live.history && <PreviewHistory />}
      {routes.personal_details.where_i_live.housing_arrangements && (
        <PreviewHousingArrangements />
      )}
    </>
  );
}
